
import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageContext } from '../../Context/MessageContext';
import Axios from 'axios';
import Config from '../../Config/Config';
import { useMsal } from "@azure/msal-react";

const useListTimeOfDays = () => {
    const rootPath = Config.api.rootPath;
    const { instance } = useMsal();
    const { t } = useTranslation();
    const { addMessage } = useContext(MessageContext);
    const [ timeOfDays, setTimeOfDays ] = useState([]);
    const [ fetchingTimeOfDays, setFetchingTimeOfDays ] = useState(true);

    /** list time of days
    * @param {string} sort - sort field 
    * @param {string} order - sort order (asc/desc) */ 
    const listTimeOfDays = async (sort='StartTime', order='asc') => {
        try {

            
            const activeAccount = instance.getActiveAccount();
            const accounts = instance.getAllAccounts();

            if (!activeAccount && accounts.length === 0) return;

            const request = {
                scopes: Config.api.scopes,
                account: activeAccount || accounts[0]
            }

            const authResult = await instance.acquireTokenSilent(request);
            
            const options = {
                "headers": {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + authResult.accessToken
                }
            }

            let result = null;

            result = await Axios.get(rootPath + "/api/v1/timeofdays?sort=" + sort + "&order=" + order, options);

            
            if (result && result.status === 200 && result.data) {
                setTimeOfDays(result.data);
                setFetchingTimeOfDays(false);
                return result;
            }

            if (result && result.status === 404) {
                addMessage({ type: "warning", header: t('general.error'), body: t('warnings.timeOfDaysNotFound') });
                setFetchingTimeOfDays(false);
                return result;
            }

            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingTimeOfDaysFailed') });
            setFetchingTimeOfDays(false);
            return result;

        } catch (error) {
            if (Config.environment === 'development' || Config.environment === 'test') console.log(error);
            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingTimeOfDaysFailed') });
            setFetchingTimeOfDays(false);
            return error;
        }
    }

    return { timeOfDays, fetchingTimeOfDays, listTimeOfDays };
}

export default useListTimeOfDays;